import { exportExcelSummary } from '../../utils/export-excel';
import { DownloadIcon } from 'src/components/ui-icons/upload';
import { RequirementColumn, Department } from '../../types/data';
import { TooltipItem } from "src/utils/Tooltip";

type ExportExcelSummaryProps = {
  data: RequirementColumn[];
  departments: Department[];
}

function ExportExcelSummary({ data, departments }: ExportExcelSummaryProps) {
  return (
    <TooltipItem position="top" tooltipsText={'Экспорт в Excel'}>
      <button
        className="rounded-md bg-white p-4 shadow-md h-full"
        type="button"
        onClick={() => exportExcelSummary(data, departments)}>
        <DownloadIcon />
      </button>
    </TooltipItem>
  )
}

export default ExportExcelSummary;
